import axios from 'axios';
import { useQuery } from 'react-query';
import Config from '../global/env';
import { TrafficAnalyticsData } from '../model/trafficanalytics';

const fetchTrafficAnalytics = async (timeRange: string): Promise<TrafficAnalyticsData> => {
    const paramOperator = /*Config.demoEnabled ? "?" :*/ "";
    const apiURL = Config.apiBaseURL + Config.trafficAnalyticsURL + `${paramOperator}/${timeRange}/${Config.defaultZone}`
    const { data } = await axios.get(apiURL);
    return data;
}

const useTrafficAnalytics = (timeRange: number = 30) => {
    return useQuery<TrafficAnalyticsData, Error>(['TrafficAnalytics', timeRange.toString()], () => fetchTrafficAnalytics(timeRange.toString()))
}

export default useTrafficAnalytics;